import { render, staticRenderFns } from "./NonActionalActionStatusModal.vue?vue&type=template&id=2bf4636d&scoped=true&"
import script from "./NonActionalActionStatusModal.vue?vue&type=script&lang=js&"
export * from "./NonActionalActionStatusModal.vue?vue&type=script&lang=js&"
import style0 from "./NonActionalActionStatusModal.vue?vue&type=style&index=0&id=2bf4636d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf4636d",
  null
  
)

export default component.exports